import { jsx as _jsx } from "react/jsx-runtime";
import { getHeadingClasses } from '#pplx/frontend/aether/primitives/HeadingPrimitive/classes.js';
export function HeadingPrimitive({ children, level = 1, color = 'inherit', family = 'sans', size = 'default', weight = 'normal', align = 'left', }) {
    const Tag = `h${level}`;
    return (_jsx(Tag, { className: getHeadingClasses({ color, family, size, weight, align }), children: children }));
}
//# sourceMappingURL=index.js.map